export default __webpack_public_path__ + "static/media/router.1e049de8.png";